// Aviso de versión nueva: una pestaña abierta antes de un despliegue sigue con
// el código viejo en memoria. Cada 5 minutos (y al volver a la pestaña) se
// compara el build cargado con el que sirve el servidor; si cambió, se ofrece recargar.
import { useEffect, useRef } from 'react';
import { Button, Group, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

const ID = 'version-nueva';

/** El build con el que se cargó esta pestaña (nombre del archivo principal). */
function versionCargada(): string | null {
  const src = [...document.querySelectorAll<HTMLScriptElement>('script[type="module"][src]')].map((s) => s.src)
    .find((s) => /\/assets\/index-[\w-]+\.js/.test(s));
  return src?.match(/(index-[\w-]+\.js)/)?.[1] ?? null;
}

export function AvisoVersion() {
  const avisado = useRef(false);
  useEffect(() => {
    const actual = versionCargada();
    if (!actual) return; // en desarrollo (Vite) no hay build
    const revisar = async () => {
      if (avisado.current) return;
      try {
        const r = await fetch('/api/version', { cache: 'no-store' });
        const { web } = (await r.json()) as { web: string | null };
        if (web && web !== actual) {
          avisado.current = true;
          notifications.show({
            id: ID, autoClose: false, withCloseButton: true, color: 'blue', title: 'Hay una versión nueva de epms',
            message: (
              <Group justify="space-between" wrap="nowrap" gap="xs">
                <Text size="sm">Recargá para ver los últimos cambios.</Text>
                <Button size="xs" onClick={() => window.location.reload()}>Recargar</Button>
              </Group>
            ),
          });
        }
      } catch {
        // sin conexión: se vuelve a probar en la próxima vuelta
      }
    };
    const t = window.setInterval(revisar, 5 * 60 * 1000);
    const alVolver = () => { if (document.visibilityState === 'visible') void revisar(); };
    document.addEventListener('visibilitychange', alVolver);
    void revisar();
    return () => { window.clearInterval(t); document.removeEventListener('visibilitychange', alVolver); };
  }, []);
  return null;
}
